import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { reducers } from './store/reducers';
import { effects } from './store/effects';

export const provideWorkflowStore = () => [
  provideState('workflow', reducers),
  provideEffects(effects)
];
